import styled from 'styled-components';
import { Text } from '../Text';
import Colors from 'constants/Colors';

export const ValidationErrorText = styled(Text)`
  display: flex;
  justify-content: flex-end;
  font-size: 12px;
  margin-top: 3px;
  color: ${Colors.DANGER};
  font-weight: 600;
  padding-bottom: 8px;
`;

export const MidDiv = styled.div`
  margin-top: 3px;
  border-radius: 6px;
  display: flex;
  background-color: ${Colors.WHITE};
  justify-content: space-between;
  box-shadow: 0 0 0 3px ${Colors.PRIMARY1};
    ${({height}) => height ? `height: ${height}px` : `height: 196px`};
    ${({height}) => height ? `max-height: ${height}px` : `max-height: 196px`};
`;

export const InnerDiv = styled.div`
  width: 100%;
  margin: 16px;
  padding-right: 16px;
  font-size: 18px;
  font-weight: 700;
  word-wrap: break-word;
  color: ${Colors.BLACK};
  background-color: ${Colors.WHITE};
  overflow: auto;
    ${({errors}) => errors && errors?.question?.idQuestion ? `box-shadow: 0 0 0 3px ${Colors.DANGER}` : ''};  
`;

export const Button = styled.button`
  align-self: flex-end;
  margin-left: auto;
  padding: 5px 10px;
  background-color: ${Colors.SECONDARY};
  border: none;
  border-radius: 4px;
  cursor: pointer;
`;

export const IconsContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 10px;

  .icon-arrowup {
    width: 20px;
    height: 20px;
    min-width: 20px;
    transition: transform ease-in-out 200ms;
    margin-left: 8px;
    cursor: pointer;

    &:before{
      background-size: 100%;
      width: 80%;
      height: 80%;
      margin: 10%;
    }
    
    &.closed {
      transform: rotate(180deg);
    }
  }
`;